// extracted by mini-css-extract-plugin
module.exports = {"modelTestBox":"modelTestBox--index--2phF5VJ","subject":"subject--index--2-ZbCvb"};